/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyOnlineCounselingSlot,
  PharmacyOnlineCounselingSlotFromJSON,
  PharmacyOnlineCounselingSlotFromJSONTyped,
  PharmacyOnlineCounselingSlotToJSON,
} from "./";

export const PharmacyOnlineCounselingSlotsTypename = "PharmacyOnlineCounselingSlots" as const;

/**
 *
 * @export
 * @interface PharmacyOnlineCounselingSlots
 */
export interface PharmacyOnlineCounselingSlots {
  /**
   *
   * @type {Array<PharmacyOnlineCounselingSlot>}
   * @memberof PharmacyOnlineCounselingSlots
   */
  onlineCounselingSlots: Array<PharmacyOnlineCounselingSlot>;
  /**
   *
   * @type {number}
   * @memberof PharmacyOnlineCounselingSlots
   */
  pharmacyId: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyOnlineCounselingSlots
   */
  readonly __typename?: string;
}

export function PharmacyOnlineCounselingSlotsFromJSON(json: any): PharmacyOnlineCounselingSlots {
  return PharmacyOnlineCounselingSlotsFromJSONTyped(json, false);
}

export function PharmacyOnlineCounselingSlotsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyOnlineCounselingSlots {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyOnlineCounselingSlotsTypename,

    onlineCounselingSlots: (json["online_counseling_slots"] as Array<any>).map(PharmacyOnlineCounselingSlotFromJSON),
    pharmacyId: json["pharmacy_id"],
  };
}

export function PharmacyOnlineCounselingSlotsToJSON(object?: PharmacyOnlineCounselingSlots | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    online_counseling_slots: (value.onlineCounselingSlots as Array<any>).map(PharmacyOnlineCounselingSlotToJSON),
    pharmacy_id: value.pharmacyId,
  };
}
